import classNames from "classnames";
import React from "react";

import styles from "./SectionImageCircled.module.scss";

type Props = {
  image: string;
  className?: string;
};

const SectionImageCircled = ({ image, className }: Props) => {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.circle} />
      <img src={image} alt="" className={styles.image} />
    </div>
  );
};

export default SectionImageCircled;
